(function () {
    'use strict';

    angular.module("imApp").factory("diaryService", ['$ihttp', function ($ihttp) {
        let call = function (method, parameters) {
            return $ihttp.post({
                method: method,
                parameters: parameters || {}
            });
        };

        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 841,
                    parameters: parms || {}
                });
            },
            listPortalUsers: function (parms) {
                return $ihttp.post({
                    method: 842,
                    parameters: parms || {}
                });
            },
            listTasks: function (parms) {
                return $ihttp.post({
                    method: 843,
                    parameters: parms || {}
                });
            },
            listOwners: function (parms) {
                return $ihttp.post({
                    method: 844,
                    parameters: parms || {}
                });
            },
            deleteCustact: function (custactNo) {
                return $ihttp.post({
                    method: 136,
                    parameters: {
                        custact_no: custactNo
                    }
                });
            },
            updateItem: function (data) {
                data.webpagename = 'diary';
                return call(849, data);
            }
        };

        return service;
    }]);
})();
